/**
* Created by lobin on 2020/6/17.
*/
<template>
  <div class="station-select">
    <div class="autocom" v-if="type ==='input'">
      <a-auto-complete
        :data-source="list.map(({ _id, name }) => ({ value: _id, text: name }))"
        style="width: 100%"
        placeholder="选择站点或者输入关键字查询"
        @search="onSearch"
        @change="onChange"
        v-model="val"
        allowClear
      />
    </div>
    <div v-else>
      <a-input-search @search="comsearch" placeholder="输入名称" v-model="name" :loading="listloading" />
      <ul class="station-select-list">
        <li class="station-select-list-item" v-if="listloading"><a-skeleton /></li>
        <li
          class="station-select-list-item" 
          :class="{selected: item._id === id }" 
          v-else v-for="(item,index) in list" 
          :key="index" @click="clickItem(item)"
        >
          {{ index + 1 }}.{{ item.name }}
        </li>
        <a-empty v-if="list.length === 0 && !listloading" style="margin-top: 40px" />
      </ul>
      <a-pagination simple :default-current="1" :total="pager.total" :pageSize="pager.pageSize" @change="pageChange" v-model="page" />
    </div>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex';

export default {
  props: ['type', 'value'],
  data() {
    return {
      page: 1,
      name: '',
      id: '',
    };
  },
  created() {
    this.getList();
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    selectItems: {
      get() {
        return this.value;
      },
    },
    ...mapState({
      list: (state) => state.station.list,
      pager: (state) => state.station.pager,
      listloading: (state) => state['@@loading'].effects.getStationList,
    }),
  },
  methods: {
    ...mapActions(['getStationList']),
    getList() {
      this.getStationList({
        name: this.name,
        page: this.page,
        pageSize: 50,
        status: 1,
      });
    },
    comsearch() {
      this.id = '';
      this.getList();
    },
    clickItem({ _id }) {
      this.id = _id;
      this.$emit('select', _id);
    },
    search(val) {
      this.name = val;
      this.getList();
    },
    handleFocus() {
      this.name = '';
      this.getList();
    },
    handleBlur() {},
    pageChange(current) {
      this.page = current;
      this.getList();
    },
    onChange(value) {
      if (value) {
        this.$emit('input', value);
      } else {
        this.$emit('input', '');
      }
    },
    onSearch(input) {
      this.name = input;
      this.getList();
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
.station{
  &-select{
    &-list{
      border: 1px solid #f4f4f4;
      padding: 0;
      margin: 10px 0;
      overflow: scroll;
      height: 440px;
      &-item{
        list-style: none;
        line-height: 2.5;
        cursor: pointer;
        padding: 0 10px;
        border-radius: 3px;
        transition: 0.2s;
        &.selected{
          background-color: #1678fd;
          color: #fff;
        }
        &:hover{
          background-color: #17ABFD;
          color: #fff;
        }
      }
    }
  }
}
</style>
